/* eslint-disable react/jsx-pascal-case */
import React, { useEffect } from 'react'
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import O_FooterModal from 'components/3_Organisms/O_FooterModal'
import A_Message from 'components/1_Atoms/A_Message'
import M_FieldCodeBox from 'components/1_Atoms/2_Molecules/M_FieldCodeBox'
import { DialogContent, DialogActions } from 'assets/DialogSet'
import { organismGroupLog } from 'utils/logUtil'
import { useButtons, useTokuiBox, useTenBox, useMailBox } from 'hooks/useUserModal'
import { buttonQueryF, clickF, voidF } from 'types/FunctionTypes'
import { useMessageModal, useOpen } from 'hooks/useModal'
import { useEnterKeyFocusControl } from 'utils/focusControlUtil'

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      // width: '100ch',
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })

type Props = {
  refetch: voidF
}

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string
  children: React.ReactNode
  onClose: buttonQueryF | clickF
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props
  const [messageColor, message] = useMessageModal()
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Grid container direction="row" alignItems="center">
        <Typography variant="h6">{children}</Typography>
        <Typography variant="h6">{'　　 '}</Typography>
        <A_Message message={message} color={messageColor} variant={'body1'} />
      </Grid>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  )
})

const O_AddUser = ({ refetch }: Props) => {
  useEffect(() => organismGroupLog('O_AddUser'))
  // 表示切替え
  const register = useEnterKeyFocusControl()
  const [open] = useOpen()
  const tokuiBox = useTokuiBox()
  const tenBox = useTenBox()
  const mailBox = useMailBox()
  const { buttons, buttonClose } = useButtons(refetch)

  return (
    <Dialog fullWidth={true} maxWidth="md" onClose={buttonClose.click} aria-labelledby="customized-dialog-title" open={open}>
      <DialogTitle id="customized-dialog-title" onClose={buttonClose.click}>
        ユーザー追加
      </DialogTitle>
      <DialogContent dividers>
        <Grid container justifyContent="flex-start" spacing={0}>
          <Grid item xs={12}>
            {/* ==== 得意先 ==== */}
            <M_FieldCodeBox key={1} tab={1} info={tokuiBox} register={register(1, 'number', async () => {}, tokuiBox.submit)} />
          </Grid>
          <Grid item xs={12}>
            {/* ==== 店舗 ==== */}
            <M_FieldCodeBox key={2} tab={2} info={tenBox} register={register(2, 'number', async () => {}, tenBox.submit)} />
          </Grid>
          <Grid item xs={12}>
            {/* ==== メールアドレス ==== */}
            <M_FieldCodeBox key={3} tab={3} info={mailBox} type="text" register={register(3, 'text', async () => {}, mailBox.submit)} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <O_FooterModal buttonInfos={buttons} buttonClose={buttonClose} />
      </DialogActions>
    </Dialog>
  )
}

export default React.memo(O_AddUser)
